import { Stack, Box, Typography, Button } from '@mui/material';
import { useCallback, useState } from 'react';
import JoinCareCircleDialog from 'src/dialogs/carecircle/JoinCareCircleDialog';
import CareCircleTerms from 'src/dialogs/carecircle/CareCircleTermsDialog';
import useCCReferral from 'src/hooks/useCCReferral';
import useLocales from 'src/hooks/useLocales';
import useAuth from 'src/hooks/useAuth';
import { UserRole } from 'src/enums/shared.enums';

export default function CareCircleBanner() {
    const { userRole } = useAuth();
    const { translate } = useLocales();
    const { referralCode, referralCodeLoading } = useCCReferral({
        queriesToRun: ['GET_REFERRAL_CODE'],
    });

    const [openDialog, setOpenDialog] = useState(false);
    const [openTermsDialog, setOpenTermsDialog] = useState(false);

    const handleOpenDialog = useCallback(() => {
        setOpenDialog(true);
    }, []);

    const handleCloseDialog = useCallback(() => {
        setOpenDialog(false);
    }, []);

    const handleToggleTermsDialog = useCallback(() => {
        setOpenTermsDialog((prev) => !prev);
    }, []);

    // Hide the banner while we resolve enrollment, and once the user is enrolled
    // (i.e. they already have a referral code).
    if (referralCodeLoading || Boolean(referralCode) || userRole !== UserRole.CLIENT) {
        return null;
    }

    return (
        <Box sx={(theme) => ({ py: 3, px: 2 })}>
            <Stack spacing={1.25} sx={{ bgcolor: 'tan.lighter', borderRadius: 1, p: 2 }}>
                <Stack direction="row" spacing={1.25} alignItems="center">
                    <Box
                        component="img"
                        src="/assets/icons/navbar/cc-banner-icon.svg"
                        alt=""
                        sx={{ width: 24, height: 24 }}
                    />
                    <Typography variant="subtitle2">
                        {translate('components.careCircle.banner.title')}
                    </Typography>
                </Stack>
                <Typography
                    variant="caption"
                    sx={{ color: 'text.secondary', letterSpacing: 0, lineHeight: 1.2 }}
                >
                    {translate('components.careCircle.banner.description')}
                </Typography>
                <Button variant="outlined" fullWidth onClick={handleOpenDialog}>
                    {translate('components.careCircle.banner.join')}
                </Button>
            </Stack>
            <JoinCareCircleDialog
                open={openDialog}
                onClose={handleCloseDialog}
                onOpenTerms={handleToggleTermsDialog}
            />
            <CareCircleTerms open={openTermsDialog} onClose={handleToggleTermsDialog} />
        </Box>
    );
}
